<template>
    <div class="editExtensionAgentGrade">
        <el-dialog title="修改推广员等级" @close="close" :visible.sync="dialogVisible" width="600px">
            <p class="tips" v-if="batch">本次选择推广员{{len}}个，其中： 普通推广员{{commonGrade}}个，高级推广员{{highGrade}}个，超级推广员{{superGrade}}</p>
            <div class="choiceGrade">
                <span>修改推广员等级为：</span> 
                <el-select placeholder="选择推广员等级" v-model="params.leveltype">
                    <el-option v-for="item in gradeList" :key="item.name" :label="item.name" :value="item.code"></el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="affirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {editGrade} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'editExtensionAgentGrade',
    data() {
        return {
            dialogVisible: false,
            grade: '',
            batch: 'false',
            highGrade: 0,
            superGrade: 0,
            commonGrade: 0,
            params: {
                leveltype: '',
                inneridList: ''
            },
            len: 0,
            gradeList: [
                {code: '1', name: '普通推广员'},
                {code: '2', name: '高级推广员'},
                {code: '3', name: '超级推广员'}
            ]
        }
    },
    methods: {
        batchEdit(len, high, common, superGrade, innerid) {
            this.len = len
            this.highGrade = high
            this.commonGrade = common
            this.superGrade = superGrade
            this.batch = true
            this.dialogVisible = true
            this.params.inneridList = innerid
        },
        openDialog(v) {
            this.dialogVisible = true
            this.len = 1
            this.params.inneridList = v.innerid
            if (v.leveltype === 1) {
                this.commonGrade = 1
            } else if (v.leveltype === 2) {
                this.highGrade = 1
            } else if (v.leveltype === 3) {
                this.superGrade = 1
            }
        },
        affirm() {
            this.setLoading(true)
            editGrade({
                data: Object.assign({}, this.params),
                success: data => {
                    this.$message.success('修改等级成功！')
                    this.setLoading(false)
                    this.dialogVisible = false
                    this.$emit('getList')
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        close() {
            this.highGrade = 0
            this.commonGrade = 0
            this.superGrade = 0
            this.params.leveltype = ''
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    .editExtensionAgentGrade{
        .el-dialog{
            .tips{
                text-align: center;
            }
            .choiceGrade{
                text-align: center;
                margin-top: 20px;
                .el-select{
                    width: 224px;
                    .el-input__suffix{
                        .el-input__suffix-inner{
                            .el-input__icon{
                                line-height: 32px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>